const GA_CATEGORIES = {
  LANDSCAPE: 'Landscape',
  TOPIC: 'Topic',
  INSIGHT: 'Insight',
  PREMISE: 'Premise',
  FEEDSOURCE: 'FeedSource',
  USER: 'User'
}

const GA_ACTIONS = {
  CREATE: 'create',
  OPENSTATS: 'openStats',
  CLOSESTATS: 'closeStats',
  INVITE: 'invite'
}

export const gaComposeEvent = (event, label, value) => {
  const data = {}
  if (label) data.eventLabel = label
  if (value) data.eventValue = value
  return Object.assign({}, event, data)
}

export const GA_EVENTS = {}
const events = [
  // Landscape
  'LANDSCAPE_CREATE',
  'USER_INVITE',
  // Feeds
  'FEEDSOURCE_CREATE',
  'FEEDSOURCE_OPENSTATS',
  'FEEDSOURCE_CLOSESTATS',
  // Topics
  'TOPIC_CREATE',
  // Insights
  'INSIGHT_CREATE',
  // Premises
  'PREMISE_CREATE'
]
events.forEach(e => {
  const s = e.split('_')
  GA_EVENTS[e] = {
    eventCategory: GA_CATEGORIES[s[0]],
    eventAction: GA_ACTIONS[s[1]]
  }
})
